<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head1">CONTENTS</p>
<p class="toc2"><a href="#/Acknowledgments">Acknowledgments</a></p>
<p class="toc2"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Part1#P1">P<span class="small">ART</span> I. T<span class="small">HE</span> C<span class="small">ULPER</span> S<span class="small">PY</span> R<span class="small">ING</span></a></p>
<p class="toc"><a href="#/Chapter1#C1">1. The Battle of Long Island</a></p>
<p class="toc"><a href="#/Chapter2#C2">2. The British Occupation</a></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. Nathan Hale and Washington’s Early Intelligence Operations</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. Creation of the Spy Ring</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. Operation of the Espionage Network</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. The Culper Letters, 1778–1779</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. The Culper Letters, 1780</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. The Culper Letters, 1781–1783</span></p>
<p class="toc"><span href="#/Chapter9#C9" title="Link target outside of Sample">9. The End of the War</span></p>
<p class="toc"><span href="#/Chapter10#C10" title="Link target outside of Sample">10. Impact of the Intelligence</span></p>
<p class="toc"><span href="#/Chapter11#C11" title="Link target outside of Sample">11. After the Revolution</span></p>
<p class="toc"><span href="#/Chapter12#C12" title="Link target outside of Sample">12. President Washington’s 1790 Tour</span></p>
<p class="toc1"><span href="#/Part2#P2" title="Link target outside of Sample">P<span class="small">ART</span> II. L<span class="small">ONG</span> I<span class="small">SLAND</span>’<span class="small">S</span> R<span class="small">EVOLUTIONARY</span> W<span class="small">AR</span> S<span class="small">ITES</span></span></p>
<p class="toc"><span href="#/Chapter13#C13" title="Link target outside of Sample">13. New York State’s George Washington Spy Trail</span></p>
<p class="toc"><span href="#/Chapter14#C14" title="Link target outside of Sample">14. Spy Ring Sites Today</span></p>
<p class="toc"><span href="#/Chapter15#C15" title="Link target outside of Sample">15. Other Sites with Ties to the Revolution</span></p>
<p class="toc1"><span href="#/Note" title="Link target outside of Sample">Notes</span></p>
<p class="toc2"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc2"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?0c815b6c